





















import { Component, Vue, Watch, Mixins } from 'vue-property-decorator';
import Pagination from '@/mixins/pagination';
import ShipmentListItem from '@/components/shipment/list/ShipmentListItem.vue';
import NavBar from '@/components/layout/NavBar.vue';
import listShipmentsQuery from '@/graphql/queries/ListShipments.gql';
import Filters from '@/components/layout/Filters.vue';
import { listShipments_shipments } from '@/types/graphql/schemaTypes';

// Options
import { defaultShipmentListStatuses } from '@/constants/shipmentStatusOptions.ts';

@Component({
  components: {
    Filters,
    NavBar,
    ShipmentListItem
  },
  apollo: {
    shipments: {
      query: listShipmentsQuery,
      prefetch: true,
      variables() {
        const query = this.$route.query;
        let operatorId = null;

        if (query.operatorId && query.operatorId !== 'all') {
          operatorId = query.operatorId;
        }
        const defaultShipments = defaultShipmentListStatuses();

        const shipmentArgs = {
          operatorId,
          cargo: query.cargo || null,
          customerOrganizationId: query.customerOrganizationId || null,
          pod: query.pod || null,
          pol: query.pol || null,
          reference: query.reference || null,
          statuses: query.status ? [query.status] : defaultShipments,
          tradeDirection: query.tradeDirection || null,
          orderBy: query.orderBy
        };

        const billingIncomplete = query.billingIncomplete === 'true' || false;

        return {
          billingIncomplete,
          shipmentArgs,
          pagination: {
            page: parseInt(this.$route.query.page, 10) || this.currentPage,
            per: parseInt(this.$route.query.size, 10) || this.pagniationSize
          }
        };
      },
      skip() {
        return !this.filtersReady;
      },
      update(data) {
        this.totalCount = data ? data.shipmentsPagination.totalCount : 0;
        return data && data.shipments;
      },
      fetchPolicy: 'network-only'
    }
  }
})
export default class Shipments extends Mixins(Pagination) {
  public shipments: listShipments_shipments[] = [];
  private filtersReady = false;
}
